// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { getFamiliesFactory, getLastWeeks } from '../../common/repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import FamilyBaseMachineGroupAvailabilityTable from './components/family-base-machine-group-availability-table';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../shared/services/common-functions';
import { getFamilyBaseMachineGroupAvailability } from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class FamilyBaseMachineGroupAvailability extends Component {

    state = {
        familyTypes: [],
        lastWeeks: [],
        selectedFamilyType: '',
        selectedLastWeek: '',
        results: null
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getFamiliesFactory( 'N', 'N' ).then( response => {

            this.setState( {
                familyTypes: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        this.props.increaseCounter();
        getLastWeeks().then( response => {

            this.setState( {
                lastWeeks: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleFamilyChange ( val ) {

        this.setState( {
            selectedFamilyType: val
        }, () => {

            this.refresh();

        } );

    }

    handleLastWeekChange ( val ) {

        this.setState( {
            selectedLastWeek: val
        }, () => {

            this.refresh();

        } );

    }

    refresh () {

        if ( this.state.selectedFamilyType && this.state.selectedLastWeek ) {

            this.props.increaseCounter();

            const { selectedFamilyType } = this.state;
            const selectedLastWeekVal = this.state.lastWeeks
                .find( lastweekObj => Number( lastweekObj.weekEnding ) ===
                Number( this.state.selectedLastWeek ) )
                .weekNumber;

            getFamilyBaseMachineGroupAvailability( selectedFamilyType, selectedLastWeekVal )
                .then( response => {

                    this.setState( {
                        results: response
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const {
            familyTypes, lastWeeks, selectedFamilyType, selectedLastWeek, results
        } = this.state;

        function buildLastWeekDate ( dateVal ) {

            const formattedVal = formatGivenDate( dateVal, 'YYYY-MM-DD' );
            if ( formattedVal === '2000-01-01' ) {

                return 'Inventory';

            } if ( formattedVal === '2000-02-01' ) {

                return 'Rework';

            }
            return formattedVal;

        }
        const lastWeekDates = lastWeeks ? lastWeeks.map( date => ( {
            label: buildLastWeekDate( date.weekEnding ), id: date.weekEnding
        } ) ) : [];

        const mapResults = [];
        let k = 1;
        const additionalInfo = { unitName: this.props.unit.name };

        if ( results !== null ) {

            // FORECASTED AVAILABILITY
            let tableResult = [];
            results.forecastAvailability.forEach( family => {

                const nestedTableResult = [];
                nestedTableResult.itemDesc = family.item;
                tableResult.push( nestedTableResult );

                const nestedForecastTDResult = {};
                nestedForecastTDResult.itemDesc = 'Forecast';

                const nestedOrderedTDResult = {};
                nestedOrderedTDResult.itemDesc = 'Total Ordered';

                Object.keys( family.availabilityDetails ).forEach( item => {

                    const forecastQty = family.availabilityDetails[item].forecast;
                    const totalorderedQty = family.availabilityDetails[item].totalordered;
                    nestedForecastTDResult[item] = forecastQty;
                    nestedOrderedTDResult[item] = totalorderedQty;

                } );
                tableResult.push( nestedForecastTDResult );
                tableResult.push( nestedOrderedTDResult );

            } );

            let tempResultWithUnitName = tableResult
                .map( i => ( { ...i, ...additionalInfo } ) );
            mapResults[k] = tempResultWithUnitName;
            mapResults[k].titleName = 'FORECASTED AVAILABILITY';
            k += 1;

            // ATP AVAILABILITY
            tableResult = [];
            results.forecastAvailability.forEach( family => {

                const nestedTableResult = [];
                nestedTableResult.itemDesc = family.item;
                tableResult.push( nestedTableResult );

                const nestedCapacityTDResult = {};
                nestedCapacityTDResult.itemDesc = 'Total Capacity';

                const nestedOrderedTDResult = {};
                nestedOrderedTDResult.itemDesc = 'Total Ordered';

                Object.keys( family.availabilityDetails ).forEach( item => {

                    const totalCapacityQty = family.availabilityDetails[item].totalCapacity;
                    const totalorderedQty = family.availabilityDetails[item].totalordered;
                    nestedCapacityTDResult[item] = totalCapacityQty;
                    nestedOrderedTDResult[item] = totalorderedQty;

                } );
                tableResult.push( nestedCapacityTDResult );
                tableResult.push( nestedOrderedTDResult );

            } );

            tempResultWithUnitName = tableResult
                .map( i => ( { ...i, ...additionalInfo } ) );
            mapResults[k] = tempResultWithUnitName;
            mapResults[k].titleName = 'ATP AVAILABILITY';
            k += 1;

            // ATP GROUP AVAILABILITY
            tableResult = [];
            results.groupAvailability.forEach( family => {

                const nestedTableResult = [];
                nestedTableResult.itemDesc = family.item;
                tableResult.push( nestedTableResult );

                const nestedCapacityTDResult = {};
                nestedCapacityTDResult.itemDesc = 'Total Capacity';

                const nestedOrderedTDResult = {};
                nestedOrderedTDResult.itemDesc = 'Total Ordered';

                Object.keys( family.availabilityDetails ).forEach( item => {

                    const totalCapacityQty = family.availabilityDetails[item].totalCapacity;
                    const totalorderedQty = family.availabilityDetails[item].totalordered;
                    nestedCapacityTDResult[item] = totalCapacityQty;
                    nestedOrderedTDResult[item] = totalorderedQty;

                } );
                tableResult.push( nestedCapacityTDResult );
                tableResult.push( nestedOrderedTDResult );

            } );
            tempResultWithUnitName = [];
            tempResultWithUnitName = tableResult
                .map( i => ( { ...i, ...additionalInfo } ) );
            mapResults[k] = tempResultWithUnitName;
            mapResults[k].titleName = 'ATP GROUP AVAILABILITY';
            k += 1;

        }

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Family, Base Machine, & Group Availability</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-family-base-machine-group-availability-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-family-base-machine-group-availability-select"
                                    label="Family"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleFamilyChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={familyTypes}
                                    placeholder="Select Family"
                                    selectedValue={selectedFamilyType}
                                />

                                <OptionsDropDown
                                    className="atp-family-base-machine-group-availability-select"
                                    label="Last Week"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleLastWeekChange.bind( this )}
                                    optionDisplayAttributes={['label']}
                                    optionKey="id"
                                    options={lastWeekDates}
                                    placeholder="Select Last Week"
                                    selectedValue={selectedLastWeek}
                                    isRequired={false}
                                />

                                {selectedFamilyType && selectedLastWeek && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                        </div>
                        {selectedFamilyType && selectedLastWeek &&
                        mapResults !== null && mapResults.map( ( item, index ) => (

                            <FamilyBaseMachineGroupAvailabilityTable
                                key={`availability-table-${index}`}
                                results={item}
                                titleName={item.titleName}
                                selectedLastWeek={selectedLastWeek}
                                lastWeeks={lastWeeks}
                            />
                        ) ) }
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

FamilyBaseMachineGroupAvailability.displayName = 'FamilyBaseMachineGroupAvailability';
FamilyBaseMachineGroupAvailability.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( FamilyBaseMachineGroupAvailability ) );
